import {Money} from '@dms/api/shared';

export type SaleVehiclePrice = {
  /**
   * Price without vat
   */
  withoutVat: Money | null;
  /**
   * Price with vat
   */
  withVat: Money | null;
  vatRate: string | null;
};
